const Auth0ErrorCodes = {
  AUTH_0_GENERIC_ERROR: 'AZ-1000',
};

Object.freeze(Auth0ErrorCodes);

export default Auth0ErrorCodes;
